import { buildDecoderUrl } from './utils/buildURLs';
import { captureScreenshot } from './utils/captureScreenshot';
import { waitForPageLoad } from './utils/waitForPageLoad';

export const handleOpenDecoderTab = async ({ action, navigate }) => {
  const url = buildDecoderUrl(action);
  navigate(url);
  await new Promise((resolve) => setTimeout(resolve, 200));

  try {
    await waitForPageLoad();

    const image = await captureScreenshot();

    let toReturn = {
      screenshot: image,
    };

    return toReturn;
  } catch (error) {
    console.error('Failed to capture screenshot:', error);
    return null;
  }
};

